"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useVisualViewportResize_1 = __importDefault(require("./useVisualViewportResize"));
const isVisualViewportSupport = 'VisualViewport' in global;
function useViewportSize(config = {}) {
    const { isEnabled = true, throttle = 20 } = config;
    const [size, setSize] = (0, react_1.useState)({});
    const updateMaxHeight = (0, react_1.useCallback)((viewport) => {
        setSize({
            width: viewport.width,
            height: viewport.height,
            offsetTop: viewport.offsetTop,
            widthPx: `${viewport.width}px`,
            heightPx: `${viewport.height}px`,
        });
    }, []);
    // On iOS there is no way to detect virtual keyboard
    // because screen and window sizes do not change on keyboard appearing
    // except using experimental visualViewport
    // https://developer.mozilla.org/en-US/docs/Web/API/VisualViewport
    (0, useVisualViewportResize_1.default)(updateMaxHeight, {
        enable: isVisualViewportSupport && isEnabled,
        throttle,
        initialize: true,
    });
    return size;
}
exports.default = useViewportSize;
//# sourceMappingURL=useViewportSize.js.map